module.exports = __webpack_public_path__ + "img/product-kahve.e2df8816.png";